/**
 * "{n} {noun}" with the singular at exactly 1: "1 unit", "0 units", "2 units".
 * Pass the plural when it is not the singular plus "s".
 */
export function countOf(n: number, singular: string, plural = `${singular}s`): string {
  return `${n} ${n === 1 ? singular : plural}`;
}
